import '.a{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { LinkAnchor } from '../link/LinkAnchor'
import useMediaQuery from '@app/util/useMediaQuery'

export type BreadcrumbLevel = {
  label: string
  to?: string
}

export type BreadcrumbsProps = {
  levels: BreadcrumbLevel[]
}

export const Breadcrumbs = ({ levels }: BreadcrumbsProps) => {
  const isMobile = useMediaQuery()

  return (
    <div className="a t u"
      style={{
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        width: isMobile ? '100%' : undefined,
      }}
    >
      {levels?.map((level, index) => (
        <Crumb
          text={level.label}
          isLast={levels?.length === index + 1}
          to={level.to}
          isMobile={isMobile}
          key={index}
        />
      ))}
    </div>
  )
}

const Crumb = ({
  text,
  isLast,
  to,
  isMobile,
}: {
  text: string
  isLast: boolean
  to?: string
  isMobile: boolean
}) => {
  return (
    <LinkAnchor
      to={to ?? '#'}
      style={{
        whiteSpace: isMobile ? 'normal' : 'nowrap',
        fontFamily: 'FunnelDisplay',
        fontWeight: isLast ? 600 : 400,
        color: isLast ? 'var(--brand-secondary)' : 'var(--palette-blue-300)',
        cursor: isLast ? 'default' : 'pointer',
        overflow: isMobile ? 'visible' : isLast ? 'hidden' : 'visible',
        textOverflow: isMobile ? undefined : isLast ? 'ellipsis' : undefined,
      }}
    >
      {isLast ? text : `${text} /`}
    </LinkAnchor>
  )
}
